import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from 'core/authentication/authentication.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private router: Router,
    private appStateService: AppStateService,
    private appInfoService: AppInfoService,
    private authenticationService: AuthenticationService
  ) { }

  /**
   * Can activate the route only if the user has access
   * @param route - The route
   * @param state - The state
   */
  canActivate() {
    if (this.appStateService.state.isOnline && !this.authenticationService.isAuthenticating) {
      if (this.appInfoService.userHasAccess() && this.appInfoService.userTypeHasAccessForPhaseOne()) {
        return true;
      } else {
        this.router.navigate(['/403', true]);
        return false;
      }
    }
    return true;
  }
}
